import { Badge } from "reactstrap";
import { DevelopmentTitle, Href } from "../../../../../Constant";
import { DEVELOPMENT_DATA } from "../../../../../Data/Learning";
import { LI, UL } from "../../../../../AbstractElements";
import { Link } from "react-router-dom";

const DevelopmentCategories = () => {
  return (
    <div className="categories pt-1">
      <div className="learning-header">
        <span className="f-w-700">{DevelopmentTitle}</span>
      </div>
      <UL>
        {DEVELOPMENT_DATA.map((data, index) => (
          <LI className="border-0" key={index}>
            <Link to={Href}>{data.DevelopmentHeading}</Link>
            <Badge color="primary" className="pull-right">{data.badgeNumber}</Badge>
          </LI>
        ))}
      </UL>
    </div>
  );
};

export default DevelopmentCategories;
